import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';

import {WithContext as ReactTags} from 'react-tag-input';

const Container = styled.div`
    div.ReactTags__tags {
        position: relative;
    }
    
    /* Styles for the input */
    div.ReactTags__tagInput {
        width: 10rem;
        border-radius: var(--space-4);
        display: inline-block;
    }
    
    div.ReactTags__tagInput input.ReactTags__tagInputField,
    div.ReactTags__tagInput input.ReactTags__tagInputField:focus {
        width: 100%;
        height: 1.875rem;
    
        padding: var(--space-8) var(--space-10);
    
        background: white;
        border: 1px solid var(--color-gray-400);
        box-sizing: border-box;
        border-radius: var(--space-4);
    
        font-weight: normal;
        font-style: normal;
        font-size: var(--space-14);
        line-height: var(--space-14);
    
        color: var(--color-gray-900);
    }
    
    /* Styles for selected tags */
    div.ReactTags__selected span.ReactTags__tag {
        display: inline-block;
    
        background: var(--color-blue-200);
        font-size: var(--font-16);
    
        margin: 0 var(--space-16) var(--space-16) 0;
    
        padding: var(--space-10) var(--space-12);
        border-radius: var(--space-6);
    
        cursor: move;
    }
    
    div.ReactTags__selected a.ReactTags__remove {
        color: var(--color-gray-900);
        margin-left: var(--space-14);
    
        font-weight: 500;
        font-size: var(--font-16);
    
        cursor: pointer;
    }
`;

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function TagsComponent({tags = [], setTags}) {
    const handleAddition = tag => setTags([...tags, tag]);

    const handleDelete = i => setTags(tags.filter((tag, index) => index !== i));

    const handleDrag = (tag, currPos, newPos) => {
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setTags(newTags);
    };

    return <Container>
        <ReactTags
            tags={tags}
            delimiters={delimiters}
            handleAddition={handleAddition}
            handleDelete={handleDelete}
            handleDrag={handleDrag}
        />
    </Container>;
}

export default TagsComponent;
